import { ListItemIcon, ListItemText } from '@/components/Dropdown/MenuItems/components';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ArrowDown from '@/images/ArrowDown.svg';
import Align from '@/images/position/align/Top.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import MenuItem from '@mui/material/MenuItem';

const RightArrow = styled(MaskedIcon)`
    transform: rotate(-90deg);
`;

const StyledListItemText = styled(ListItemText)`
    width: 100%;
`;

export const AlignMenuItem = () => {
    return (
        <MenuItem>
            <ListItemIcon>
                <MaskedIcon src={Align} color={theme.colors.secondary.main} size="16px" />
            </ListItemIcon>
            <StyledListItemText>Align</StyledListItemText>
            <RightArrow src={ArrowDown} color={theme.colors.secondary.main} size="16px" />
        </MenuItem>
    );
};
